import { render, staticRenderFns } from "./PlayerTransferStart.vue?vue&type=template&id=90febee8&scoped=true&"
import script from "./PlayerTransferStart.vue?vue&type=script&lang=js&"
export * from "./PlayerTransferStart.vue?vue&type=script&lang=js&"
import style0 from "./PlayerTransferStart.vue?vue&type=style&index=0&id=90febee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90febee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90febee8')) {
      api.createRecord('90febee8', component.options)
    } else {
      api.reload('90febee8', component.options)
    }
    module.hot.accept("./PlayerTransferStart.vue?vue&type=template&id=90febee8&scoped=true&", function () {
      api.rerender('90febee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PlayerTransferStart.vue"
export default component.exports